<template>
  <div class="content-editor-block-wrapper h-100" :style="isSubBlock ? '' : 'margin: 22px 0;'">

    <i v-if="sortable !== false" class="el-icon-s-grid drag-icon" style="cursor: grab;position: absolute;left: -30px;"></i>

    <el-popover
      placement="top"
      v-model="isClosePopoverShown"
      v-if="removable !== false">
      <p>確定刪除此區塊？</p>
      <div style="text-align: right; margin: 0">
        <el-button size="mini" type="text" @click="isClosePopoverShown = false">取消</el-button>
        <el-button type="danger" size="mini" @click="remove">刪除</el-button>
      </div>
      <i class="el-icon-error icon-close" slot="reference"></i>
    </el-popover>

    <div class="block-title-wrapper clickable">
      <div class="relative" :style="value.type == 'video' ? 'width: 110px;' : (value.type == 'videofromurl' ? 'width: 130px;' : '')">

          <el-dropdown v-if="allowChangeType" @command="changeType" placement="top-start">
            <p class="block-title">{{title}}<i class="el-icon-arrow-down"></i></p>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(entityInfo, idx) in allowedEntities"
                :key="`content-editor-block-${index}-type-list-${idx}`"
                :command="entityInfo.type"
                :icon="entityInfo.icon">
                {{entityInfo.name}}
              </el-dropdown-item>

            </el-dropdown-menu>
          </el-dropdown>

      </div>
    </div>

    <title-editor v-if="value.type == 'title'" v-model="mValue.value" @input="onInput"/>
    <subtitle-editor v-if="value.type == 'subtitle'" v-model="mValue.value" @input="onInput"/>
    <content-editor v-if="value.type == 'content'" v-model="mValue.value" @input="onInput"/>
    <quote-editor v-if="value.type == 'quote'" v-model="mValue.value" @input="onInput"/>
    <comment-editor v-if="value.type == 'comment'" v-model="mValue.value" @input="onInput"/>
    <link-editor v-if="value.type == 'link'" v-model="mValue.value" @input="onInput"/>
    <youtube-link-editor v-if="value.type == 'video'" v-model="mValue.value" @input="onInput"/>
    <video-from-u-r-l-editor v-if="value.type == 'videofromurl'" v-model="mValue.value" @input="onInput"/>
    <carousel-editor v-if="value.type == 'carousel'" v-model="mValue.value" @input="onInput">
      <template slot="items" slot-scope="scope">
        <div class="sub-block">
          <content-editor-block
            v-model="scope.items[scope.page-1]"
            :is-sub-block="true"
            :allow-types="['image','video']"
            :sortable="false"
            removable
            @input="onInput"
            @remove="scope.onRemoved(scope.page)"/>
        </div>
      </template>
    </carousel-editor>
    <image-editor v-if="value.type == 'image'" v-model="mValue.value" @input="onInput"/>
    <code-editor v-if="value.type == 'code'" v-model="mValue.value" @input="onInput"/>
    <h-t-m-l-code-editor v-if="value.type == 'htmlcode'" v-model="mValue.value" @input="onInput"/>

    <div v-if="value.type == 'complex'" class="flex">
      <div class="sub-block">
        <content-editor-block
          v-model="mValue.value.value1"
          :is-sub-block="true"
          :sortable="false"
          removable
          @input="onInput"
          @remove="onRemoveComplex1"/>
      </div>
      <div class="sub-block">
        <content-editor-block
          v-model="mValue.value.value2"
          :is-sub-block="true"
          :sortable="false"
          removable
          @input="onInput"
          @remove="onRemoveComplex2"/>
      </div>
    </div>
  </div>
</template>

<script>
import TitleEditor from '@/utils/content-editor/components/blocks/TitleEditor.vue'
import SubtitleEditor from '@/utils/content-editor/components/blocks/SubtitleEditor.vue'
import ContentEditor from '@/utils/content-editor/components/blocks/ContentEditor.vue'
import QuoteEditor from '@/utils/content-editor/components/blocks/QuoteEditor.vue'
import CommentEditor from '@/utils/content-editor/components/blocks/CommentEditor.vue'
import LinkEditor from '@/utils/content-editor/components/blocks/LinkEditor.vue'
import ImageEditor from '@/utils/content-editor/components/blocks/ImageEditor.vue'
import VideoFromURLEditor from '@/utils/content-editor/components/blocks/VideoFromURLEditor.vue'
import YoutubeLinkEditor from '@/utils/content-editor/components/blocks/YoutubeLinkEditor.vue'
import CarouselEditor from '@/utils/content-editor/components/blocks/CarouselEditor.vue'
import CodeEditor from '@/utils/content-editor/components/blocks/CodeEditor.vue'
import HTMLCodeEditor from '@/utils/content-editor/components/blocks/HTMLCodeEditor.vue'
import Entity from '@/utils/content-editor/entities.js'
export default {
  name: 'content-editor-block',
  components: {
    TitleEditor,
    SubtitleEditor,
    ContentEditor,
    QuoteEditor,
    CommentEditor,
    LinkEditor,
    VideoFromURLEditor,
    YoutubeLinkEditor,
    CarouselEditor,
    ImageEditor,
    CodeEditor,
    HTMLCodeEditor
  },
  props: {
    value: {
      default: ''
    },
    isSubBlock: {
      default: true
    },
    removable: {
      default: false
    },
    sortable: {
      default: false
    },
    index: {},
    allowTypes: {
      default: () => {
        return Entity.types
      }
    }
  },
  data: () => {
    return {
      mValue: {},
      isClosePopoverShown: false
    }
  },
  computed: {
    title () {
      return (Entity.all.find(o => o.type === this.value.type) || {}).name
    },
    allowChangeType () {
      return this.value.type !== 'complex'
    },
    Entities () {
      return Entity.all
    },
    allowedEntities () {
      return this.Entities.filter(o => this.allowTypes.includes(o.type)).filter(o => !this.isSubBlock || (o.type !== 'complex' && o.type !== 'carousel'))
    }
  },
  methods: {
    onRemoveComplex1 () {
      this.mValue.value.value2.id = this.mValue.id
      this.$emit('input', this.mValue.value.value2)
    },
    onRemoveComplex2 () {
      this.mValue.value.value1.id = this.mValue.id
      this.$emit('input', this.mValue.value.value1)
    },
    onInput () {
      this.$emit('input', this.mValue)
    },
    remove () {
      this.isClosePopoverShown = false
      this.$emit('remove')
    },
    changeType (newType) {
      let oldType = this.mValue.type

      let getDataStringByType = (data, type) => {
        var oldString = ''
        if (type === 'title') {
          oldString = data.value
        } else if (type === 'subtitle') {
          oldString = data.value
        } else if (type === 'content') {
          oldString = data.value
        } else if (type === 'quote') {
          oldString = data.value
        } else if (type === 'comment') {
          oldString = data.value
        } else if (type === 'link') {
          oldString = (data.value.title || '') + (data.value.url || '')
        } else if (type === 'image') {
          oldString = data.value.title
        } else if (type === 'video') {
          oldString = data.value.id
        } else if (type === 'videofromurl') {
          oldString = data.value
        } else if (type === 'carousel') {
          oldString = ''
        } else if (type === 'code') {
          oldString = data.value
        } else if (type === 'htmlcode') {
          oldString = data.value
        } else if (type === 'complex') {
          oldString = getDataStringByType(
            data.value.value1.value,
            data.value.value1.type
          )
        } else {
          console.error('unknown old type ' + oldType)
        }
        return oldString
      }

      let oldString = getDataStringByType(this.mValue, this.mValue.type)

      let id = this.mValue.id
      if (newType === 'title') {
        this.mValue = new Entity.Title(id)
        this.mValue.value = oldString
      } else if (newType === 'subtitle') {
        this.mValue = new Entity.Subtitle(id)
        this.mValue.value = oldString
      } else if (newType === 'content') {
        this.mValue = new Entity.Content(id)
        this.mValue.value = oldString
      } else if (newType === 'quote') {
        this.mValue = new Entity.Quote(id)
        this.mValue.value = oldString
      } else if (newType === 'comment') {
        this.mValue = new Entity.Comment(id)
        this.mValue.value = oldString
      } else if (newType === 'link') {
        this.mValue = new Entity.Link(id)
        this.mValue.value.title = oldString
      } else if (newType === 'image') {
        this.mValue = new Entity.Image(id)
        this.mValue.value.title = oldString
      } else if (newType === 'video') {
        this.mValue = new Entity.Video(id)
        this.mValue.value.id = oldString
      } else if (newType === 'videofromurl') {
        this.mValue = new Entity.VideoFromURL(id)
        this.mValue.value = oldString
      } else if (newType === 'carousel') {
        this.mValue = new Entity.Carousel(id)
      } else if (newType === 'code') {
        this.mValue = new Entity.Code(id)
        this.mValue.value = oldString
      } else if (newType === 'htmlcode') {
        this.mValue = new Entity.HTMLCode(id)
        this.mValue.value = oldString
      } else if (newType === 'complex') {
        this.mValue = new Entity.Complex(id)
        this.mValue.value.value1.value = oldString
      } else {
        console.error('unknown new type ' + newType)
      }
      this.mValue.type = newType
      this.$emit('input', this.mValue)
    }
  },
  created () {
    this.mValue = this.value
  },
  watch: {
    value () {
      this.mValue = this.value
    }
  }
}
</script>
